module.exports = __webpack_public_path__ + "img/benoit12.32bca72f.jpg";